export type ContentCategory = "drama" | "characters" | "news";

export interface DramaArticle {
  id: string;
  title: string;
  cover: string;
  summary: string;
  content: string[];
  tags: string[];
  year: string;
  author: string;
  date: string;
  readTime: string;
}

export type CharacterRole = "主角" | "配角" | "反派";

export interface CharacterItem {
  id: string;
  name: string;
  avatar: string;
  role: CharacterRole;
  actor: string;
  position: string;
  summary: string;
  background: string[];
  traits: string[];
}

export interface NewsItem {
  id: string;
  title: string;
  cover: string;
  summary: string;
  content: string[];
  tags: string[];
  date: string;
  author: string;
  source: string;
  hot: number;
}

export interface UnifiedContent {
  id: string;
  category: ContentCategory;
  title: string;
  summary: string;
  cover: string;
  date: string;
  tags: string[];
}

export const CATEGORY_LABEL: Record<ContentCategory, string> = {
  drama: "剧集剧情",
  characters: "角色介绍",
  news: "影视资讯",
};

export const CATEGORY_PATH: Record<ContentCategory, string> = {
  drama: "/category/drama",
  characters: "/category/characters",
  news: "/category/news",
};